import { cn } from 'lib/utils';
import { getHttpMethodBadgeClasses, resolveActionMethod } from './tool-detail-utils';

type ToolMethodBadgeProps = {
  method?: string;
};

export function ToolMethodBadge({ method }: ToolMethodBadgeProps) {
  const label = resolveActionMethod({ Method: method });

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap',
        getHttpMethodBadgeClasses(label === 'API' ? undefined : label),
      )}
    >
      {label}
    </span>
  );
}
